import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NextDaySchedule } from '../../types/dashboard.types';
import './ScheduleCard.styles.css';

interface ScheduleCardProps {
  schedule: NextDaySchedule | null;
}

export const ScheduleCard: React.FC<ScheduleCardProps> = ({ schedule }) => {
  const navigate = useNavigate();

  const handleViewPlanning = () => {
    navigate('/expert/planning');
  };

  return (
    <div className="dashboard-card schedule-card">
      <div className="dashboard-card-header">
        <h3 className="dashboard-card-title">Prochaines visites</h3>
        {schedule && (
          <span className="info-badge">{schedule.count} visite{schedule.count > 1 ? 's' : ''}</span>
        )}
      </div>
      <div className="schedule-list">
        {schedule ? (
          <div className="schedule-day-section">
            <div className="schedule-day-header">
              <span className="schedule-day-label">{schedule.label}</span>
            </div>
            {schedule.visits.slice(0, 3).map(visit => (
              <div key={visit.id} className="schedule-item">
                <div className="schedule-time">{visit.time}</div>
                <div className="schedule-details">
                  <div className="schedule-property">{visit.property}</div>
                  <div className="schedule-client">{visit.client}</div>
                </div>
              </div>
            ))}
            {schedule.visits.length > 3 && (
              <div className="schedule-more">
                Et {schedule.visits.length - 3} autre{schedule.visits.length - 3 > 1 ? 's' : ''} visite{schedule.visits.length - 3 > 1 ? 's' : ''}...
              </div>
            )}
          </div>
        ) : (
          <div className="empty-state">Aucune visite prévue</div>
        )}
      </div>
      <div className="card-footer">
        <button 
          className="btn-outline-small"
          onClick={handleViewPlanning}
        >
          Voir le planning complet
        </button>
      </div>
    </div>
  );
};